export default "__VITE_ASSET__DJJla1lt__"